import { Emitter } from './emitter';

const MAX_SPEED = 160;

class Random extends Emitter<number> {
  acceleration = 20;
  speed = 0;
  interval: number | null = null;

  start() {
    this.interval = window.setInterval(() => {
      this.acceleration += (0.5 - Math.random()) * 10;
      this.speed += this.acceleration;
      if (this.speed <= 0) {
        this.speed = 0;
        this.acceleration *= -0.9;
      }
      if (this.speed >= MAX_SPEED) {
        this.speed = MAX_SPEED;
        this.acceleration *= -0.9;
      }
      this.emit(Math.round(this.speed));
    }, 1000);
  }

  stop() {
    if (this.interval !== null) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}

export default new Random();
